import { render, staticRenderFns } from "./ManageClubCostDeduction.vue?vue&type=template&id=06963bb6&"
import script from "./ManageClubCostDeduction.vue?vue&type=script&lang=js&"
export * from "./ManageClubCostDeduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports